import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class FoldersMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: FoldersMetaModule,
            providers: [
                providePageMeta({
                    title: 'Folders',
                    translationKey: 'page_units',
                    routerLink: '/folders',
                    sidebarSection: 'Management',
                    icon: 'folder',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 0,
                }),
            ],
        };
    }
}
